module.exports = __webpack_public_path__ + "assets/img/gaurang_bhatnagar_photo.104af0e5.svg";